import setIgnoreStartDate from './setIgnoreStartDate';

/**
 * Detect if any configuration is applicable to curent page and returns it.
 * 
 * @memberof _helpers 
 * @param {Object} config 
 * @returns {Object} - {page, config} Configured page URL and its configuration object
 */
/* eslint-disable complexity */
function getPageConfig(config) {
    const location = window.location;
    
    if (!location.origin) {
        const port = location.port ? ':' + location.port: '';
        window.location.origin = `${location.protocol}//${location.hostname}${port}`;
    }
    
    const currentPage = `${location.origin}${location.pathname}`.replace(/\/$/, '');

    let pageKey;

    // If has configured parts of the URL to be replaced
    for (const partToReplace in config.meta.pagesPartsMapping) {
        if (!config.meta.pagesPartsMapping.hasOwnProperty(partToReplace)) { continue; }
        const regExp = new RegExp(partToReplace);
        if (pageKey !== undefined || regExp.test(currentPage) === false) { continue; }
        pageKey = currentPage.replace(new RegExp(partToReplace), config.meta.pagesPartsMapping[partToReplace]);
    }

    // If URL contains domain keywords to exclude and pageKey is still undefined
    const originExclusionKeywords = ['ngtst', 'ngtest', 'ngdev', 'stg-ng', 'stg-www', 'cloudfront', '.avp.ru', 'localhost', 'lo.kaspersky.com', 'dm.kaspersky.com', 'kaspersky-labs.com'];
    const ignorestartdate = originExclusionKeywords.reduce((ignore, keyword) => ignore || location.href.match(keyword) !== null, pageKey !== undefined);

    let page = pageKey || currentPage;

    if (ignorestartdate && pageKey === undefined) {
        const keys = Object.keys(config.pages);
        const configuredOrigin = keys[0].split('/').slice(0, 3).join('/');
        page = currentPage.replace(location.origin, configuredOrigin);
    }

    const pageConfig = setIgnoreStartDate(config.pages[page], ignorestartdate);

    return { page, pageConfig };
}

export default getPageConfig;
